module.exports = "<p>\r\n  test2 works!\r\n</p>\r\n"